const INITIAL_STATE = {
  showModal: false,
  modalType: "none",
  modalTitle: "",
  modalContent: "",
  modalFooter: "",
  showCloseButton: true
};
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "SHOW_MODAL":
      return {
        ...state,
        showModal: true,
        showCloseButton: action.payload.showCloseButton !== undefined ? action.payload.showCloseButton : true,
        modalType: action.payload.modalType,
        modalTitle: action.payload.modalTitle,
        modalContent: action.payload.modalContent,
        modalFooter: action.payload.modalFooter,
        modalElementId: action.payload.modalElementId,
        modalCustomClassName: action.payload.modalCustomClassName,
      };
    case "HIDE_MODAL":
      return INITIAL_STATE;
    default:
      return state;
  }
};
